import {IResult} from ".";

export class Result implements IResult {
  public page:number = 0;
  public itemsPerPage: number = 0;
  public total: number = 0;
  public items: any[] = [];
}
